import React from 'react';

/**
 * A Marketplace listing's icon: the publisher's uploaded image when there is one,
 * otherwise the emoji it was created with, or its type's icon (TypeGlyph).
 */
const ListingIcon: React.FC<{ iconUrl?: string; emoji: React.ReactNode; className: string; alt: string }> = ({ iconUrl, emoji, className, alt }) => (
  <div className={`${className}${iconUrl ? ' ms-icon--image' : ''}`}>
    {iconUrl ? <img src={iconUrl} alt={alt} /> : emoji}
  </div>
);

export default ListingIcon;
